/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 40, height = 28, fill = "none" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className="border border-gray-3 rounded-lg"
    xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd"><circle cx="7" cy="12" fill="#ea001b" r="7"/>
      <circle cx="17" cy="12" fill="#ffa200" fillOpacity=".8" r="7"/>
    </g>
  </svg>
);

export default SvgComponent;
